import { UUIDIdentity } from "@ascend-ltd/accounts-core";
import * as Sentry from "@sentry/nextjs";
import Cookies from "js-cookie";

export const setupSentry = async () => {
  initBrowserUserId();
};

const initBrowserUserId = () => {
  const oldCookie = Cookies.get("browser_user_id");
  if (oldCookie) {
    Sentry.setExtra("browser_user_id", oldCookie);
    return;
  }

  const newCookie = UUIDIdentity.generate().getValue();
  Cookies.set("browser_user_id", newCookie);
  Sentry.setExtra("browser_user_id", newCookie);
};

export const setupSentryUser = (user?: {
  userId?: string;
  tenantId?: string;
  tenantName?: string;
  tenantSlug?: string;
  userRole?: string;
}) => {
  if (typeof user === "undefined") {
    Sentry.setUser({});
    Sentry.setTag("tenantSlug", null);
    Sentry.setTag("tenantName", null);
    Sentry.setContext("USER", null);
    return;
  }
  Sentry.setUser({
    id: user.userId,
    ...user,
  });
  Sentry.setTag("tenantSlug", user.tenantSlug);
  Sentry.setTag("tenantName", user.tenantName);
  Sentry.setContext("USER", { user });
};
